import React, { useCallback, useEffect, useMemo, useState } from 'react';
// Types
import { FilterProps } from 'pages/EventLog/types/eventLog';
// Utils
import { isEmptyObject, useSetState, getSessionStorageItem } from 'utils'; 
// Auth Context
import { useAuthState } from 'context/AuthContext';
// App Context
import { useAppDispatch } from 'context/AppContext';
// Event Context
import { useEventDispatch, useEventState } from 'context/EventContext';
import { setEventFilters } from 'context/EventContext/actions';
import { getEvents } from 'context/EventContext/middleware';
// Elements
import Button from 'elements/Button';
import { Loading } from 'elements/Loading';
// Assets
import Icon from 'assets/Icon';
// Style
import styles from './style/eventFilterBar.module.css';

function EventFilterBar() {
  // Auth State
  const { defaultOrganisation: { orgRef } } = useAuthState();
  // Event State
  const { eventFilters, noMoreEvent, events } = useEventState();
  const eventDispatch = useEventDispatch();
  // App State
  const appDispatch = useAppDispatch();
  // State
  const [disabled, setDisabled] = useState(false);
  const defaultState = useMemo(() => ({
    processingStatus: ['LINES_IN_ERROR', 'ERROR'],
    limit: '10',
    offSet: 0,
    orgRef: getSessionStorageItem({ item: 'defaultOrganisation' }).orgRef,
  }), []);
  const [state, setState] = useSetState(isEmptyObject(eventFilters) ? defaultState : eventFilters);

  const getData = useCallback(async (filters:FilterProps) => {
    if ( eventFilters.offSet !== filters.offSet || filters.offSet === 0) {
      await getEvents({
        appDispatch,
        eventDispatch,
        filters,
        orgRef,
      });
      setDisabled(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventDispatch, orgRef]);

  const handleUpdateAuto = useCallback(async (filters:FilterProps) => {
    eventDispatch(setEventFilters(filters));
  }, [eventDispatch]);

  async function handleNext() {
    setDisabled(true);
    setState({ offSet : Number(state.offSet) + 10 });
    eventDispatch(setEventFilters({ ...eventFilters, offSet : Number(eventFilters.offSet) + 10 }));
  }

  useEffect(() => {
    if (!isEmptyObject(eventFilters) && eventFilters.orgRef === defaultState.orgRef) {
      getData(eventFilters);
    } else {
      handleUpdateAuto(defaultState);
    }
  }, [defaultState, eventFilters, getData, handleUpdateAuto]);

  return (
    <div className={styles.seeMore}>
      {disabled ?
        <Button btnStyle="secondary" btnType="icon" label="loading">
          <Loading fill="white" size={32} />
        </Button>
        : null }
      { !disabled && noMoreEvent && events.length > 0 ?
        <Button
          btnSize="small"
          btnType="iconBefore"
          elevation="2-4"
          disabled={disabled}
          handler={() => handleNext()}
        > 
          <Icon
            icon="ExpandMore"
          />
          See More
        </Button> : null}
    </div>
  );
}

export default EventFilterBar;